module.exports = __webpack_public_path__ + "static/media/insta.e75dcb70.svg";